
export default function useRandomColor() {
  function generateRandomHexColor() {
    // Generate random values for RGB components
    const r = Math.floor(Math.random() * 256); // Random red value between 0 and 255
    const g = Math.floor(Math.random() * 256); // Random green value between 0 and 255
    const b = Math.floor(Math.random() * 256); // Random blue value between 0 and 255

    // Convert RGB to hexadecimal representation
    const hexColor = `#${r.toString(16).padStart(2, "0")}${g
      .toString(16)
      .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;

    return hexColor;
  }
  return { generateRandomHexColor };
}
